import { createContext } from 'react';
/**
 * Default values for AppShell's shared state.
 */
export const defaultContext = {
    appShellId: 'app-shell',
    appLinks: [],
    appLinksWithHome: [],
    isAppSidebarExpanded: false,
    toggleAppSidebar: () => { },
};
/**
 * Context for AppShell's shared state.
 */
export const appShellContext = createContext(defaultContext);
